import React, { useState, useCallback } from "react";
import {
  SettingToggle,
  Banner,
  Card,
  Icon,
  TextContainer,
  Heading,
  Button,
} from "@shopify/polaris";
import callApi from "../../utils/apiCaller";
import { useSelector, useDispatch } from "react-redux";
import { actFetchDataSettings, actFetchShowLoadingPage } from "../../actions";
import { Col, Row } from "reactstrap";
import {
  DeleteMajor,
  DomainNewMajor,
  DuplicateMinor,
} from "@shopify/polaris-icons";
import logoOT from "../../assets/logo_ot.png";
import uuid from "uuid-random";
import CopyToClipboard from "react-copy-to-clipboard";
const Key = () => {
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false);
  const dataSettings = useSelector((state) => state.dataSettings);
  const generateOtAPIKey = () => {
    let params = {
      action: "generateKey",
    };
    dispatch(actFetchShowLoadingPage(true));
    callApi("get", params, "order_tracking/services.php").then(async (res) => {
      dispatch(actFetchShowLoadingPage(false));
      if (res.status === 200) {
        let newDataSettings = { ...dataSettings };
        newDataSettings.order_tracking_api_key = res.data.key;
        dispatch(actFetchShowLoadingPage(false));
        dispatch(actFetchDataSettings(newDataSettings));
      }
    });
  };
  const deleteAPIKey = () => {
    let params = {
      action: "deleteAPIKey",
    };
    dispatch(actFetchShowLoadingPage(true));
    callApi("get", params, "order_tracking/services.php").then(async (res) => {
      if (res.status === 200) {
        let newDataSettings = { ...dataSettings };
        newDataSettings.order_tracking_api_key = null;
        dispatch(actFetchShowLoadingPage(false));
        dispatch(actFetchDataSettings(newDataSettings));
      }
    });
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Card sectioned title="Manage key">
        <Row>
          <Col md={12}>
            <div className="integration-page-layout text-center">
              <div className="text-center">
                <img src={logoOT} style={{ width: "200px" }} />
              </div>
              {dataSettings.order_tracking_api_key ? (
                <div>
                  <Row className="connection-key-layout mt-4 p-3">
                    <Heading>API key:</Heading>{" "}
                    <span className="key">
                      {dataSettings.order_tracking_api_key}
                    </span>
                    <CopyToClipboard
                      text={dataSettings.order_tracking_api_key}
                      onCopy={() => setCopied(true)}
                    >
                      <span className="ml-3">
                        <Button
                          icon={DuplicateMinor}
                          primary={copied? false : true}
                        > {copied ? "Copied!" : "Copy"} </Button>
                      </span>
                    </CopyToClipboard>
                    <span className="ml-3">
                      <Button onClick={() => deleteAPIKey()} icon={DeleteMajor}>
                        Delete
                      </Button>
                    </span>
                  </Row>
                </div>
              ) : (
                <div className="text-center">
                  <div className="p-2">
                    <TextContainer>
                      <p className="mt-3" style={{ fontSize: "16px" }}>
                        To integrate SyncTrack into the Order Tracking app, you
                        need to generate a connection key, then copy and paste
                        it into Order Tracking
                      </p>
                    </TextContainer>
                  </div>
                  <div className="p-3">
                    <Button onClick={generateOtAPIKey} primary>
                      Generate a API key
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default Key;
